import React from 'react';
import classNames from 'classnames';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from '../../components/ErrorFallback';
import MainHeader from '../../components/main-header/main-header';
import MainFooter from '../../components/main-footer/main-footer';

const WalletShell = ({children}) => {
    const [menuFlag, setMenuFlag] = React.useState(false);
    const setMenuFlagCallback = React.useCallback((val) => setMenuFlag(val), []);
    
    return (
        <div className='display-flex flex-direction-column wallet'>
            <MainHeader menuFlag={menuFlag} setMenuFlag={setMenuFlagCallback}/>
            <div className={classNames({'hide-small': menuFlag}, 'flex-1 display-flex flex-direction-column')}>
                <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
                    {children}
                </ErrorBoundary>
            </div>
            <div className='hide-small'>
                <MainFooter/>
            </div>
        </div>
    )
};

export default React.memo(WalletShell);